export const JobTitles = [
  "None",
  "Account Executive",
  "Account Manager",
  "Account Representative",
  "Accountant",
  "Accounting Analyst",
  "Accounting Director",
  "Accounts Payable/Receivable Clerk",
  "Administrator",
  "Agent",
  "Application Developer",
  "Area Sales Manager",
  "Artificial Intelligence Engineer",
  "Assistant Engineer",
  "Assistant Manager",
  "Auditor",
  "B2B Sales Specialist",
  "Barber",
  "Barista",
  "Barrister",
  "Beautician",
  "Bellhop",
  "Benefits Manager",
  "Biological Engineer",
  "Bookkeeper",
  "Budget Analyst",
  "Bus Person",
  "Cafeteria Worker",
  "Caregiver",
  "Cashier",
  "Casino Host",
  "CCO—Chief Customer Officer",
  "CDO—Chief Data Officer",
  "CEO—Chief Executive Officer",
  "CFO—Chief Financial Officer",
  "Chartered Legal Executive",
  "Chef",
  "Chemical Engineer",
  "Chief",
  "Chief Engineer",
  "CHRO—Chief Human Resources Officer",
  "CIO—Chief Information Officer",
  "Civil Engineer",
  "Client Service Specialist",
  "Cloud Architect",
  "CMO—Chief Marketing Officer",
  "CNA",
  "Commercial Loan Officer",
  "Computer Programmer",
  "Computer Scientist",
  "Concierge",
  "Content Creator",
  "Controller",
  "COO—Chief Operating Officer",
  "Coordinator",
  "Cosmetologist",
  "Counsel",
  "CPO—Chief Product Officer",
  "Credit Authorizer",
  "Credit Counselor",
  "Cruise Director",
  "Cruise Ship Attendant",
  "CTO—Chief Technology Officer",
  "Customer Care Associate",
  "Customer Service",
  "Customer Service Manager",
  "Customer Support",
  "Data Entry",
  "Dental Hygienist",
  "DevOps Engineer",
  "Direct Salesperson",
  "Director",
  "Director of Inside Sales",
  "Director of Maintenance",
  "Doctor",
  "Drafter",
  "Economist",
  "Electrical Engineer",
  "Engineer",
  "Engineering Technician",
  "Entertainment Specialist",
  "Esthetician",
  "Event Planner",
  "Events Manager",
  "Executive",
  "Fast Food Worker",
  "Finance Director",
  "Finance Manager",
  "Financial Analyst",
  "Financial Planner",
  "Financial Services Representative",
  "Flight Attendant",
  "Foreman",
  "Front Desk Associate",
  "Front Desk Manager",
  "Geological Engineer",
  "Group Sales",
  "Hair Stylist",
  "Head",
  "Health Care Provider",
  "Health Care Specialist",
  "Help Desk",
  "Help Desk Worker/Desktop Support",
  "Hotel Front Door Greeter",
  "Hotel Manager",
  "Hotel Receptionist",
  "Housekeeper",
  "Influencer",
  "Information Security Analyst",
  "IT Manager",
  "IT Professional",
  "Judge",
  "Law Enforcement",
  "Lawyer / Advocate",
  "Lead",
  "Line Cook",
  "Litigation Executive",
  "Lobbyist",
  "Lodging Manager",
  "Maintenance Engineer",
  "Makeup Artist",
  "Manager",
  "Manicurist",
  "Market Development Manager",
  "Marketer",
  "Massage Therapy",
  "Mechanical Engineer",
  "Medical Administrator",
  "Medical Laboratory Tech",
  "Medical Transcriptionist",
  "Meeting Planner",
  "Merchandising Associate",
  "Mining Engineer",
  "Nail Technician",
  "Network Administrator",
  "Nuclear Engineer",
  "Nurse",
  "Nurse Practitioner",
  "Officer",
  "Orderly",
  "Organizer",
  "Outside Sales Manager",
  "Overseer",
  "Paralegal",
  "Payroll Clerk",
  "Payroll Manager",
  "Personal Trainer",
  "Petroleum Engineer",
  "Pharmacist",
  "Pharmacy Assistant",
  "Phlebotomist",
  "Physical Therapist",
  "Physical Therapy Assistant",
  "Plant Engineer",
  "Police Officer",
  "Politician",
  "Porter",
  "President",
  "Principal",
  "Production Engineer",
  "Quality Engineer",
  "Real Estate Broker",
  "Reiki Practitioner",
  "Reservationist",
  "Restaurant Chain Executive",
  "Restaurant Manager",
  "Retail Worker",
  "Safety Engineer",
  "Sales Analyst",
  "Sales Associate",
  "Sales Engineer",
  "Sales Manager",
  "Sales Representative",
  "Salon Manager",
  "Server",
  "Skin Care Specialist",
  "Software Engineer",
  "Solicitor",
  "Spa Manager",
  "SQL Developer",
  "Store Manager",
  "Superintendent",
  "Supervisor",
  "Talent Manager",
  "Team Leader",
  "Technical Specialist",
  "Technical Support Specialist",
  "Telework Nurse/Doctor",
  "Travel Agent",
  "Travel Nurse",
  "UX Designer & UI Developer",
  "Valet",
  "Virtual Assistant",
  "Wait Staff Manager",
  "Waiter/Waitress",
  "Web Designer",
  "Web Developer",
  "Wedding Coordinator",
];

export const JobTitleItems = JobTitles.map((title) => {
  return {
    label: title,
    id: title,
  };
});
